import { formatDateMoment, getRatingImage } from 'utils/utils'
import icThreeDots from 'assets/images/ic-three-dots.svg'
import { Button } from 'avo-ui'

export const TABLE_REVIEW = {
    name: 'Review',
    column: [
        {
            name: 'Produk',
            key: 'produk',
            render: ({ item }) => (
                <div className={'flex flex-row gap-3 items-center'}>
                    <img className={'w-7 h-7'} src={item?.product_image} alt={item?.product_name} />
                    <div>{item?.product_name}</div>
                </div>
            ),
        },
        {
            name: 'Rating',
            key: 'rating',
            className: 'justify-center',
            render: ({ value }) => (
                <div className={'flex space-x-1'}>
                    {getRatingImage(value).map((item, index) => (
                        <img key={index} src={item} alt={'star'} className={'w-3'} />
                    ))}
                </div>
            ),
        },
        {
            name: 'Skin Type',
            key: 'skin_type',
            className: 'capitalize',
        },
        {
            name: 'Review',
            key: 'review',
            width: 350,
            render: ({ value, onClickItem }) => (
                <div className={'flex space-x-3 items-center justify-between'}>
                    <p className={'line-clamp-3'}>{value}</p>
                    <Button icon={icThreeDots} className={'!rounded-full'} onClick={() => onClickItem(value)} />
                </div>
            ),
        },
        {
            name: 'Created At',
            key: 'created_at',
            render: ({ value }) => formatDateMoment(value, 'DD MMM YYYY'),
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    page: 1,
    limit: 20,
}
